import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createContext, useContext, useState } from "react";
var defaultElectionEventContext = {
    ElectionEventId: null,
    setElectionEventId: function () { return undefined; },
};
export var ElectionEventContext = createContext(defaultElectionEventContext);
export var ElectionEventContextProvider = function (props) {
    var _a = useState(localStorage.getItem("selected-election-event-id") || null), ElectionEvent = _a[0], setElectionEvent = _a[1];
    var setElectionEventId = function (ElectionEventId) {
        localStorage.setItem("selected-election-event-id", ElectionEventId || "");
        setElectionEvent(ElectionEventId);
    };
    // Setup the context provider
    return (_jsx(ElectionEventContext.Provider, { value: {
            ElectionEventId: ElectionEvent,
            setElectionEventId: setElectionEventId,
        }, children: props.children }));
};
export var useElectionEventStore = function () {
    var _a = useContext(ElectionEventContext), ElectionEventId = _a.ElectionEventId, setElectionEventId = _a.setElectionEventId;
    return [ElectionEventId, setElectionEventId];
};
